export function testHasNonEmptyItems(items) {
  if (Array.isArray(items)) {
    return items.some((item) => item.length > 0);
  }
  return false;
}
